import { render, staticRenderFns } from "./banklisterror.vue?vue&type=template&id=a45f7d4c"
import script from "./banklisterror.vue?vue&type=script&lang=js"
export * from "./banklisterror.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports